import React from 'react';
import Cell from '../common/Cell';

export default function HeadCell({ alignment, children }) {
  return (
    <div>
      <Cell alignment={alignment}>{children}</Cell>
    </div>
  );
}
